module.exports = __webpack_public_path__ + "media/images/member/60x60-0cb7eb8a157336cec0705b8c5eb0db49.png";